// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2CDDY","containerItemsCenter":"Skeleton_containerItemsCenter__1XYEQ"};